import { IVehicleDetailsState } from './vehicle-details.props';

export const initialState: IVehicleDetailsState = {
  mainTab: { activeIndex: 0 },
  leasingTab: { openedContract: null }
};
